import "./MoreInformation.css";
import vestingStartImage from "../../img/vestingStart.png";

export const VestingStart = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column flex flex-column ">
      <text className="sub-title">Start date</text>
      <text className="paragraph">
        The vesting period for founders typically starts when they begin working
        for the company. This is because the vesting period is meant to
        incentivize the founder to remain with the company and to continue
        making contributions to its success. Starting the vesting period when
        the founder begins working for the company aligns the interests of the
        founder and the company and helps ensure that both parties are working
        towards a common goal.
      </text>
      <text className="paragraph">
        However, if a founder has already been working for the company (under
        incorporation) for a while, it is possible to backdate the vesting start
        date to reflect the time the founder has already spent working for the
        company (under incorporation). This is not required, and the decision to
        backdate the vesting start date is usually made on a case-by-case basis,
        depending on the circumstances and the goals of the founding team and
        the company.
      </text>
      <text className="paragraph">
        If founders are only starting the vesting period now, although they have
        been working for the company for a couple of years, this can be seen as
        a sign of their commitment to the company and their belief in its
        success. Starting the vesting period later rather than earlier can
        indicate that the founder is confident in the company's future and
        willing to make a long-term commitment. Typically, this is also what
        investors would like to see.
      </text>
      <text className="sub-title mt-4">
        Different start dates for founders?
      </text>
      <text className="paragraph">
        If founders did not start working for the company at the same time, they
        may agree on different vesting period start dates. Different vesting
        start dates can help to align the interests of each founder with the
        company and can help to reflect the level of contribution expected in
        the future on the one hand and recognize the contributions from each
        founder already performed in the past on the other hand.
      </text>
    </div>
    <div className="info-column flex">
      <img src={vestingStartImage} className="info-image mr-auto ml-auto" />
    </div>
  </div>
);
